// import { combineReducers } from 'redux';

// import Auth from './auth/reducers';
// import Layout from './layout/reducers';
// import PageTitle from './pageTitle/reducers';
// import { businessReducer } from './business/reducers';
// import { languageReducer } from './business/reducers';

// export default combineReducers({
//     Auth,
//     Layout,
//     PageTitle,
//     business: businessReducer,
//     language: languageReducer,
// });

import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import PageTitle from './pageTitle/reducers';
import { businessReducer } from './business/reducers';
import { languageReducer } from './business/reducers';
import MenuManagementCategoryReducer from './menuManagementCategory/reducers';
import MenuManagementItemReducer from './menuManagementItem/reducers';

import RecipeIngredientsManagementReducer from './recipeIngredientsManagement/reducers';
import RecipeManagementReducer from './recipeManagement/reducers';
import ContactUsReducer from './contactUs/reducers';
// import ContactUsReducer from './contactUs/reducers';
import subsAndPlansReducer from './subscriptionsAndPlans/reducers';
import modulesReducer from './module/reducers';
import settingsReducer from './settings/reducers';
import dashboardReducer from './dashboard/reducers';
import variantsReducer from './variants/reducers';

const rootReducer = combineReducers({
    Auth,
    Layout,
    PageTitle,
    business: businessReducer,
    language: languageReducer,
    category: MenuManagementCategoryReducer,
    MenuManagementItemReducer,
    ingredient: RecipeIngredientsManagementReducer,
    recipe: RecipeManagementReducer,
    contactUs: ContactUsReducer,
    // contactUs: ContactUsReducer,
    subsAndPlans: subsAndPlansReducer,
    modules: modulesReducer,
    settings: settingsReducer,
    dashboard: dashboardReducer,
    variants: variantsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
